module.exports = __webpack_public_path__ + "img/pg-banner.8ed15d10.png";